<template>
  <div class="reportingbox" title="举报须知">
    <h3>感谢您对科研诚信建设的关注与支持。为维护良好科研生态，郑重倡导负责任地行使监督权利，在提交举报前务必仔细阅读以下举报须知。</h3>
    <h3>一 、受理范围:</h3>
    <p>在项目的申请、评审、实施、结题和成果发表与应用等活动中发生的科研不端行为，具体包括</p>
    <p>(一)抄袭剽窃、侵占他人研究成果或项目申请书;</p>
    <p>(二)编造研究过程、伪造研究成果，买卖实验研究数据，伪造、篡改实验研究数据、图表、结论、检测报告或用户使用报告等;</p>
    <p>(三)买卖、代写、代投论文或项目申报验收材料等，虚构同行评议专家及评议意见;</p>
    <p>(四)以故意提供虚假信息等弄虚作假的方式或采取请托、贿赂、利益交换等不正当手段获得科研活动审批，获取科技计划（专项、基金等）项目、科研经费、奖励、荣誉、职务职称等;</p>
    <p>(五)以弄虚作假方式获得科技伦理审查批准，或伪造、篡改科技伦理审查批准文件等;</p>
    <p>(六)无实质学术贡献署名等违反论文、奖励、专利等署名规范的行为;</p>
    <p>(七)重复发表，引用与论文内容无关的文献，要求作者非必要地引用特定文献等违反学术出版规范的行为;</p>
    <p>(八)其他科研失信行为。</p>
    <h3>二、受理条件:</h3>
    <p>(一)有明确的举报对象;</p>
    <p>(二)举报内容属于上述受理范围;</p>
    <p>(三)有明确的违规事实;</p>
    <p>(四)有客观、明确的证据材料或可查证线索。</p>
    <h3>三、不予受理情形</h3>
    <p>(一)举报内容不属于上述受理范围;</p>
    <p>(二)没有明确的证据和可查证线索的;</p>
    <p>(三)对同一对象重复举报且无新的证据、线索的;</p>
    <p>(四)已经作出生效处理决定且无新的证据、线索的。</p>
    <h3>四、提倡实名举报（请提供有效身份信息和准确联系方式），举报人对举报事实的真实性负责，不得捏造、歪曲事实，不得诬告、陷害他人。应提供完整事实依据和有效证明材料；对于故意捏造事实、实施诬告陷害行为的，将依法依规追究其相应法律责任与纪律责任。</h3>
    <p style="color:red">请注意涉及国家秘密的举报，请勿通过本网站提交。</p>
    <el-checkbox v-model="checked">我已阅读并同意以上条款</el-checkbox>
     <!-- <el-divider></el-divider> -->
     <br>
    <div class="jc-c">
        <div type="primary" @click="realname" class="real-name">
            <img src="../../../assets/img/themes/real-name.png" alt="">
            实名举报
        </div>
    <div type="warning" @click="anonymous " class="anonymous">
        <img src="../../../assets/img/themes/anonymous.png" alt="">
        匿名举报
    </div>
    </div>
  </div>
</template>

<script>
export default {
data () {
    return {
        checked: false
    }
},
methods: {
    realname(){
        if(this.checked == false){
            this.$message({
          message: '请先阅读以上条款',
          type: 'warning'
        });
        } else {
            this.$router.push(
                {
                    path:"/research-integrity/realname",
                    query:{
                        id:1
                    }
                }
            )
        }
    },
    anonymous(){
        if(this.checked == false){
            this.$message({
          message: '请先阅读以上条款',
          type: 'warning'
        });
        } else {
            this.$router.push(
                {
                    path:"/research-integrity/anonymous",
                    query:{
                        id:1
                    }
                }
            )
        }
    }
}
}
</script>

<style lang="scss" scoped>
body{
    overflow: auto !important;
}
// ::v-deep
.reportingbox{

    width: 1200px;
    margin: 0 auto;
    overflow: auto;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 0 20px;
    border-top: 3px solid #1E8CE6;
    margin-top: 20px;
}
p{
    margin: 0;
    line-height: 28px;
}
.anonymous{
width: 200px;
height: 50px;
background: #FF850C;
display: flex;
align-items: center;
justify-content: center;
color: #FFFFFF;
cursor: pointer;
}
.real-name{
    width: 200px;
height: 50px;
background: #157ED6;
display: flex;
align-items: center;
justify-content: center;
color: #FFFFFF;
margin-right: 20px;
cursor: pointer;
}
</style>
